module.exports = __webpack_public_path__ + "img/pop-quiz-intro-title.ce159664.svg";